import { Box, Stack, Typography } from "@mui/material";
import StepIcon from "./StepIcon";

const ROW_STATUS = { failed: "error", running: "running" };

/** One observed step. Indented rows sit beneath the task they advanced. */
export default function TimelineRow({ row, streaming = false, nested = true }) {
  const status = ROW_STATUS[row.status] ?? "done";
  return (
    <Stack
      direction="row"
      sx={{ gap: 1, alignItems: "flex-start", pl: nested ? 2.5 : 0 }}
    >
      <Box sx={{ width: 14, display: "flex", justifyContent: "center" }}>
        <StepIcon status={status} streaming={streaming} />
      </Box>
      <Stack sx={{ gap: 0.15, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 15,
            color:
              status === "running"
                ? "var(--app-text-primary)"
                : "var(--app-text-secondary)",
            fontStyle: row.attribution === "inferred" ? "italic" : "normal",
          }}
        >
          {row.label}
        </Typography>
        {row.summary ? (
          <Typography
            sx={{ fontSize: 13, color: "var(--app-text-secondary)" }}
          >
            {row.summary}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
}
